import { render, staticRenderFns } from "./ComplexTables.vue?vue&type=template&id=a8ed23f6&"
import script from "./ComplexTables.vue?vue&type=script&lang=js&"
export * from "./ComplexTables.vue?vue&type=script&lang=js&"
import style0 from "./ComplexTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports